import { arcgisToGeoJSON } from '@terraformer/arcgis';
import type { Geometry } from 'geojson';
import * as projectOperator from '@arcgis/core/geometry/operators/projectOperator';
import { SpatialReferenceWgs84 } from './spatialReference';

/** Normalizes ArcGIS draw geometry to a WGS84 GeoJSON Point or Polygon. */
export async function arcgisGeometryToGeoJson(
  geometry: __esri.GeometryUnion
): Promise<Geometry> {
  await projectOperator.load();

  const projected = projectOperator.execute(geometry, SpatialReferenceWgs84);
  const geoJson = arcgisToGeoJSON(projected.toJSON());

  return geoJson;
}
